import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';
import { Button, Loading, Modal, Progress } from 'react-daisyui';
import { useTranslation } from 'react-i18next';
import { useModalsContext } from '../../../../../../providers/ModalsProvider/Modals.context.ts';
import { useSyncConversationsContext } from '../../../../../../providers/SyncConversationsProvider/SyncConversations.context.tsx';
import { SyncConversationsEnum } from '../../../../../../providers/SyncConversationsProvider/SyncConversations.enum.ts';
import useSyncConversationsSelect from './SyncConversationsSelect.hook.ts';
import './SyncConversationsSelect.styles.scss';
import Conversation from './components/Conversation/Conversation.component.tsx';

export default function SyncConversationsSelect() {
  const { syncConversationsStatus, setSyncConversationsStatus } =
    useModalsContext();
  const { loading, metaError, progressBar } = useSyncConversationsSelect();
  const { t } = useTranslation('dashboard/dashboard');
  const { conversations } = useSyncConversationsContext();

  return (
    <Modal
      className="SyncConversationsSelect w-full max-w-4xl"
      open={syncConversationsStatus === SyncConversationsEnum.SELECTING}
    >
      <div className="SyncConversationsSelect__Container">
        <div className="SyncConversationsSelect__Title">
          {!loading && (
            <div className="SyncConversationsSelect__Title__Text">
              <strong>
                {t('components.modals.SyncConversations.select.title', {
                  conversationsLength: conversations.length,
                })}
              </strong>
            </div>
          )}
        </div>
        {loading ? (
          <div className="SyncConversationsSelect__LoadingContent">
            <div className="SyncConversationsSelect__Loader">
              <Loading color="primary" />
            </div>

            {/*TODO: Change when we have the selected channel*/}
            <div className="SyncConversationsSelect__Progress">
              {progressBar} %
            </div>
            <Progress
              value={progressBar}
              max={100}
              color="primary"
              className="text-primary SyncConversationsSelect__ProgressBar"
            />
          </div>
        ) : (
          <div className="SyncConversationsSelect__Content">
            <div className="SyncConversationsSelect__Content__Header">
              <p className="SyncConversationsSelect__Content__Header__Space"></p>
              <p className="SyncConversationsSelect__Content__Header__Left">
                {t('components.modals.SyncConversations.select.headerLeft')}
              </p>
              <p className="SyncConversationsSelect__Content__Header__Rigth">
                {t('components.modals.SyncConversations.select.headerRight')}
              </p>
            </div>
            <div className={`SyncConversationsSelect__Content__Body`}>
              {!conversations || conversations?.length === 0 ? (
                <div className="SyncConversationsSelect__Content__Body__ErrorContent">
                  <div className="SyncConversationsSelect__Content__Body__ErrorContent__MetaError">
                    {metaError && (
                      <p>
                        {t(
                          'components.modals.SyncConversations.select.metaMessage',
                          { metaError },
                        )}
                      </p>
                    )}
                    <ChatBubbleLeftRightIcon className="w-10 h-10 mx-auto" />
                    <p>
                      {t(
                        'components.modals.SyncConversations.select.noConversationsError',
                      )}
                    </p>
                  </div>
                </div>
              ) : (
                <>
                  {conversations.map((conversation, index) => (
                    <Conversation key={index} index={index} {...conversation} />
                  ))}
                </>
              )}
            </div>
            <div className="SyncConversationsSelect__Content__Body__Conversations">
              <div className="SyncConversationsSelect__Content__Body__Conversations__Content">
                {conversations?.length <= 0 ? (
                  <Button
                    onClick={() => {
                      setSyncConversationsStatus(SyncConversationsEnum.HIDDEN);
                    }}
                    color="primary"
                    className="text-base-100"
                  >
                    {t(
                      'components.modals.SyncConversations.select.syncLaterButton',
                    )}
                  </Button>
                ) : (
                  <Button
                    color="primary"
                    className="text-base-100"
                    onClick={() => {
                      setSyncConversationsStatus(SyncConversationsEnum.SYNCING);
                    }}
                  >
                    {t('components.modals.SyncConversations.select.syncButton')}
                  </Button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}
